import { type User } from "@/services/user";
import { BuildMode } from "@/types";

export enum EventName {
  Messaging_IWantToTalkClick = "mkt_messages-funnel-click",
  Messaging_ConversationStarted = "mkt_messages-funnel-first-message",
  Messaging_FirstReaction = "mkt_messages-funnel-first-reaction",
  AiIdentification_Requested = "dev_ai_identification_request",
  AiIdentification_Completed = "dev_ai_vision_identification_completed",
  AiIdentification_Successful = "dev_ai_identification_successful",
  AiIdentification_Unsuccessful = "dev_ai_identification_unsuccessful",
  AiIdentification_ItemCreated = "dev_ai_vision_item_created",
  AiIdentification_LimitedPopupShown = "mkt_ai_vision_limited_popup_shown",
  AiIdentification_SaveIntoCollectionClick = "mkt_ai_vision_save_into_collection_click",
  AiIdentification_NextIdentificationClick = "mkt_ai_vision_next_identification_click",
  AiIdentification_UnauthorizedError = "mkt_ai_vision_unauthorized_error",
  AiIdentification_UploadImageBtn_DeadClick = "dev_ai_identification_nahrajFotografii_deadclick",
  AiIdentification_IdentifyBtn_DeadClick = "dev_ai_identification_identifikujKartu_deadclick",
  Registration_FromBestDeals = "dev_registration_from_bestdeals",
  Cart_AddItem_FromBestDeals = "dev_cart_additem_from_bestdeals",
  ShowPricesSettingsChange = "dev_user_show_prices",
  EmailNotVerifiedDialog = "dev_registration_verify_email",
  Marketing_CernyRytirBanner_Click = "mkt_cerny_rytir_banner_click",
  Dashboard_BannerFreeShipping_Click = "mkt_dashboard_bannerFreeShipping_click",
  Menu_AiIdentificationCta_Click = "mkt_menu_aiIdentification_click",
  Menu_AddItemCta_Click = "mkt_menu_add-Item_click",
  Marketplace_CartDialogContinue_Click = "mkt_basketDialog_continue",
  Marketplace_CartDialogGoToBasket_Click = "mkt_basketDialog_goToBasket",
  Marketplace_DisabledPayByCard_Click = "mkt_basket_step2_payByCardDisabled",
  Marketplace_SecuredPaymentDialogLink1_Click = "mkt_basket_step2_savePaymentLink_DialogShown",
  Marketplace_SecuredPaymentDialogLink2_Click = "mkt_basket_step2_savePaymentLink2_DialogShown",
  Marketplace_ToCartBtn_User_Click = "mkt_marketplace_detail_toBasket_click",
  Marketplace_ToCartBtn_NoUser_Click = "mkt_marketplace_detali_toBasketToLogin_click",
  Marketplace_OfferPriceOpenDialog_Click = "dev_offerPrice_step1",
  Marketplace_SubmitOfferPrice_Click = "dev_offerPrice_step2",
  Marketplace_OfferedPriceRatio_Data = "dev_offerPrice_ratio",
  Marketplace_TopCategoryTile_Click = "dev_marketplace_tile_click",
  Marketplace_TopItem_Click = "dev_marketplace_favoriteItems_click",
  Marketplace_ListItem_CreatedViaAiIdentification = "dev_marketplace_listItem_via_aiIdentification",
  Marketplace_ListItem_CreatedViaAddItemDialog = "dev_marketplace_listItem_via_addItem",
  Topbar_CartBtn_Click = "mkt_topbar_cart_click",
  Topbar_MenuBtn_Click = "mkt_topbar_menu_click",
  AddItem_ToCollection_Click = "mkt_addItemDialog_toCollectio_click",
  AddItem_ToMarketplace_Click = "mkt_addItemDialog_toMarketplace_click",
  Pagination_Prev_Click = "dev_pagination_minus1",
  Pagination_Next_Click = "dev_pagination_plus1",
  Pagination_More_Click = "dev_pagination_more",
  Gamification_Profile_Click = "dev_gamification_click_userProfile",
  Gamification_UserMenu_Click = "dev_gamification_click_userMenu",
  Dashboard_HodnotaPanel_DeadClick = "dev_dashboard_hodnotaPanel_deadclick",
  Dashboard_TrzisteTab_Click = "dev_dashboard_trziste_tab_click",
  Dashboard_TrzisteContent_Click = "dev_dashboard_trziste_content_click",
  Dashboard_LastItemsContent_Click = "dev_dashboard_lastItems_content_click",
  WebsiteSearch_Submit = "dev_hp_search_submit",
}

export type PostHogObject = {
  capture: (...args: unknown[]) => void;
  identify: (id: string) => void;
};

export const trackEvent = async (event: EventName, params?: Record<string, string | number | boolean /* feel free to extend types if needed */>): Promise<void> => {
  if (isTrackingAllowed()) {
    getPostHogObject()?.capture(event, params);
  }
};

export const identifyUser = async (user: User): Promise<void> => {
  if (isTrackingAllowed()) {
    getPostHogObject()?.identify(user.email);
  }
};

const isTrackingAllowed = (): boolean => {
  const allowedModes = [BuildMode.Production, BuildMode.Beta];
  const mode = import.meta.env.MODE as BuildMode;
  return allowedModes.includes(mode);
};

const getPostHogObject = (): PostHogObject | undefined => {
  if (typeof window.posthog === "undefined") {
    console.warn("DEV: Should not happen. PostHog not found.");
    return undefined;
  } else {
    return window.posthog;
  }
};
